export default __webpack_public_path__ + "static/media/arrow.11ec11e5.svg";